import { render } from "./LoadingWrapper.vue?vue&type=template&id=11f9edf8&scoped=true"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js"

import "./LoadingWrapper.vue?vue&type=style&index=0&id=11f9edf8&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f9edf8"]])

export default __exports__